<template>
  <v-icon v-if="!image" :icon="defaultIcon" />
  <v-img v-else :src="image" :width="width" :height="height" alt="image" />
</template>

<script setup lang="ts">
const {
  organizationId,
  fileType,
  width = undefined,
  height = undefined,
  defaultIcon = "image",
} = defineProps<{
  organizationId: string
  fileType: "icon" | "logo"
  width?: string
  height?: string
  defaultIcon?: string
}>()

const config = useRuntimeConfig()
const organizationStore = useOrganizationStore()

const { data: image } = useLazyAsyncData(
  `organization-file:${organizationId}-${fileType}`,
  async () => {
    if (config.public.ENVIRONMENT_TIER !== "production") {
      return null
    }

    switch (fileType) {
      case "icon":
        return organizationStore.getIcon(organizationId)
      case "logo":
        return organizationStore.getLogo(organizationId)
    }
  },
  {
    // Prevent executing multiple calls at the same time
    dedupe: "defer",
  },
)
</script>
